export default __webpack_public_path__ + "static/media/RR310_Frente.7151c392.webp";